import usePost from './usePost'
import useCurrent from './useCurrent';
import useFetch from './useFetch';

const useLogs = () => {
    const _url = process.env.REACT_APP_LOGS_API_BASE_URL;
    const {data:resultLogsPost,loading:loadingLogsPost,error:errorLogsPost,postData} = usePost();
    const {currentTenantId,currentCompany,currentBranchId,userId,userName} = useCurrent();
    const shouldSkipLogs = !_url || window.location.hostname === 'apps.absat-erp.com';
    const logsFetchUrl = !shouldSkipLogs && currentTenantId ? `${_url}/${currentTenantId}` : null;
    const {data:resultLogsFetch,loading:loadingLogsFetch,error:errorLogsFetch} = useFetch(logsFetchUrl, Boolean(logsFetchUrl));

    const postDataHandler = async({moduleName,resourceName,eventName,logContentEn,logContentAr}) => {
        
        if (shouldSkipLogs || !currentTenantId) return;
        const _data = {
            appId: "000000",
            tenantId: currentTenantId,
            companyId: currentCompany,
            branchId: currentBranchId,
            userId:userId,
            userName: userName,
            moduleName: moduleName,
            resourceName: resourceName,
            eventName:eventName,
            logContentEn: logContentEn,
            logContentAr: logContentAr
        }
        await postData(_url,_data)
    }

    return {
        resultLogsPost,
        loadingLogsPost,
        errorLogsPost,
        postDataHandler,
        resultLogsFetch,
        loadingLogsFetch,
        errorLogsFetch
    }
}

export default useLogs
